/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  Package,
  Clock,
  MapPin,
  X,
  Eye,
  EyeOff,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { applyStoreDraft } from "../../redux/store/store";

export default function ActivationNordetouest() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);
  const isConnected =
    store.Userguid !== null &&
    store.Userguid !== "" &&
    store.Userguid !== false &&
    store.Userguid !== undefined &&
    store.ApitokenNord !== null &&
    store.ApitokenNord !== "" &&
    store.ApitokenNord !== false &&
    store.ApitokenNord !== undefined;

  const [showGuid, setShowGuid] = useState(false);
  const [showToken, setShowToken] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);

  useEffect(() => {
    // تحديث حالة الـ sidebar استنادًا إلى عرض الشاشة
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    // استدعاء الوظيفة عند تحديث حجم الشاشة
    window.addEventListener("resize", handleResize);

    // قم بتشغيل الوظيفة مرة عند تحميل الصفحة لتحديد الحالة الابتدائية
    handleResize();

    // إلغاء تسجيل الاستماع عندما يتم تفريغ المكون
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [data, setData] = useStoreFormDraft(store);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://app.noest-dz.com/api/public/create/order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            user_guid: store.Userguid,
            api_token: store.ApitokenNord,
          }),
        },
      );

      if (response.status !== 422) {
        Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.activationFailed.title"),
          text: t("activationCompanies.alerts.activationFailed.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
        });
        return;
      }
      const result = await response.json();
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));
      setData(data);

      Swal.fire({
        icon: "success",
        title: t("activationCompanies.alerts.activationSuccess.title"),
        confirmButtonText: t("activationCompanies.alerts.confirmButton"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      console.error("Erreur :", error);
      Swal.fire({
        icon: "error",
        title: t("activationCompanies.alerts.activationError.title"),
        text: `${error.message}`,
        confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.confirmText",
      ),
      cancelButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.cancelText",
      ),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = { ...data };
        delete updatedData.Userguid;
        delete updatedData.ApitokenNord;

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));
        setData(updatedData);

        await Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div className="min-h-[400px] h-fit p-6 dark:!bg-[#181819] dark:!text-gray-200">
      <h3 className="text-lg font-semibold text-[#9e68ba] mb-3">
        {t("activationCompanies.nordetouest.title")}
      </h3>
      <Form onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.nordetouest.accountIdLabel")}
          </p>
          <Form.Group className="mb-3">
            <div className="relative mb-3">
              <Form.Control
                type={showGuid ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.nordetouest.accountIdPlaceholder1",
                )}
                value={data.Userguid || ""}
                onChange={(e) => setData({ ...data, Userguid: e.target.value })}
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowGuid(!showGuid)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showGuid ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <div className="relative mb-3">
              <Form.Control
                type={showToken ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.nordetouest.accountIdPlaceholder2",
                )}
                value={data.ApitokenNord || ""}
                onChange={(e) =>
                  setData({ ...data, ApitokenNord: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowToken(!showToken)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showToken ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <Form.Text className="text-muted dark:!text-gray-400">
              {t("activationCompanies.nordetouest.accountIdHint")}
            </Form.Text>
          </Form.Group>
        </div>

        {/* Tips Section */}
        <div
          className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4 
                    dark:!bg-[#181919] dark:!border-[#3c3a3d]"
        >
          <h4 className="font-medium text-xl text-[#9e68ba] mb-2 d-flex align-items-center">
            <Info size={18} className="ml-2" />
            {t("activationCompanies.nordetouest.tipsTitle")}
          </h4>
          <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
            <li className="d-flex align-items-start mb-2">
              <Truck
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.nordetouest.tips.delivery")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Package
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.nordetouest.tips.data")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Clock
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.nordetouest.tips.tracking")}</span>
            </li>
            <li className="d-flex align-items-start">
              <MapPin
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.nordetouest.tips.zones")}</span>
            </li>
          </ul>
        </div>

        <div className="d-flex justify-content-between mt-4">
          {!isConnected ? (
            <Button
              type="submit"
              disabled={loading}
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "rgb(141, 93, 167)",
                borderColor: "rgb(141, 93, 167)",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("activationCompanies.nordetouest.activating")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("activationCompanies.nordetouest.activate")}
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDeactivate}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("activationCompanies.nordetouest.deactivate")}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
